import Navigation from "../components/Navigation";
import HeroSection from "../components/HeroSection";
import ProductsSection from "../components/ProductsSection";
import FeaturesSection from "../components/FeaturesSection";
import SolutionsSection from "../components/SolutionsSection";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";

const LandingPage = ({ onOpenWaitlist }) => {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Navigation onOpenWaitlist={onOpenWaitlist} />
      <main>
        <HeroSection onOpenWaitlist={onOpenWaitlist} />
        <ProductsSection />
        <FeaturesSection />
        <SolutionsSection />
        <CTASection onOpenWaitlist={onOpenWaitlist} />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
